import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import React, { useMemo, useState } from 'react';
import { Icon } from "@syarahtech/ui";
import useHelpers from '@hooks/useHelpers';
import { useParams } from "react-router-dom";
import { useTranslation } from "@i18n";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import { If } from "@componentsShared/Conditional/If";
var RatingComponent = function RatingComponent(_ref) {
  var _ref$hideCta = _ref.hideCta,
    hideCta = _ref$hideCta === void 0 ? false : _ref$hideCta;
  var _useState = useState('rating'),
    currentState = _useState[0],
    setCurrentState = _useState[1];
  var _useState2 = useState(0),
    selectedRating = _useState2[0],
    setSelectedRating = _useState2[1];
  var _useState3 = useState(0),
    hoveredRating = _useState3[0],
    setHoveredRating = _useState3[1];
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var params = useParams();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _usePriceOfferContext = usePriceOfferContext(),
    remote_actions = _usePriceOfferContext.remote_actions;
  var request_id = useMemo(function () {
    return params.request_id;
  }, [params.request_id]);
  var handleStarClick = function handleStarClick(rating) {
    setSelectedRating(rating);
  };
  var handleStarHover = function handleStarHover(rating) {
    setHoveredRating(rating);
  };
  var handleStarLeave = function handleStarLeave() {
    setHoveredRating(0);
  };
  var submitRating = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var res;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(selectedRating === 0)) {
              _context.n = 1;
              break;
            }
            console.error("No rating selected");
            return _context.a(2);
          case 1:
            _context.n = 2;
            return remote_actions.fetch_priceOfferRate(selectedRating.toString());
          case 2:
            res = _context.v;
            if (res !== null && res !== void 0 && res.success) {
              setCurrentState('success');
            } else {
              console.error("Failed to submit rating:", res);
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function submitRating() {
      return _ref2.apply(this, arguments);
    };
  }();
  var goToMainPage = function goToMainPage() {
    navigateTo("/");
  };
  var renderStars = function renderStars() {
    var interactive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var rating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var stars = [];
    var displayRating = interactive ? hoveredRating || selectedRating : rating;
    var _loop = function _loop(i) {
      var isFilled = i <= displayRating;
      stars.push(/*#__PURE__*/React.createElement(Icon, {
        icon: "material-symbols--star-rounded",
        key: i,
        className: "transition-all duration-200 ".concat(interactive ? 'cursor-pointer hover:scale-110' : '', " ").concat(isFilled ? 'fill-yellow-400 text-yellow-400' : 'fill-gray-300 text-gray-300')
        // @ts-ignore
        ,
        onClick: interactive ? function () {
          return handleStarClick(i);
        } : undefined,
        onMouseEnter: interactive ? function () {
          return handleStarHover(i);
        } : undefined,
        onMouseLeave: interactive ? handleStarLeave : undefined,
        width: 9,
        height: 9
      }));
    };
    for (var i = 1; i <= 5; i++) {
      _loop(i);
    }
    return stars;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, currentState === 'rating' && /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-6 border border-solid border-gray-200 flex flex-col gap-8 rounded-lg animate-fade-in"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-base text-center text-primary font-bold"
  }, tShort("price_offer/rating_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center gap-2"
  }, renderStars(true))), selectedRating > 0 && /*#__PURE__*/React.createElement("button", {
    className: "w-full bg-primary text-white p-3 rounded-lg font-bold hover:bg-primary-120 transition-all duration-300 animate-fade-in outline-0 border-none text-xs max-w-[213px] mx-auto cursor-pointer",
    onClick: submitRating
  }, tShort("price_offer/rating_submit", {
    ns: "web_sell_trade"
  }))), currentState === 'success' && /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-6 border border-solid border-gray-200 flex flex-col gap-8 rounded-lg animate-fade-in"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-base text-center text-primary font-bold"
  }, tShort("price_offer/rating_success_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] text-base font-regular text-center"
  }, tShort("price_offer/rating_success_description", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement(If, {
    condition: !hideCta
  }, /*#__PURE__*/React.createElement("button", {
    onClick: goToMainPage,
    className: "w-full bg-primary text-white p-3 rounded-lg font-bold hover:bg-primary-120 transition-colors outline-0 border-none text-xs max-w-[213px] mx-auto cursor-pointer"
  }, tShort("price_offer/rating_success_button", {
    ns: "web_sell_trade"
  }))))));
};
export default RatingComponent;